export const styles = {
  headerMenu: {
    justifyContent: 'flex-end',
    minWidth: '28rem',
  },
  headline: {
    fontSize: '20px',
    lineHeight: '24px',
    pb: 0.5,
  },
};
